<template>
  <v-tooltip
    top
    class="pa-0"
    color="transparent"
    content-class="volume-discount-tooltip"
    v-if="getQtyDiscountLinesFromItem(item, buySell).length > 0"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon class="ml-2" v-bind="attrs" v-on="on">mdi-ticket-percent</v-icon>
    </template>
    <v-card>
      <v-card-text>
        <volume-discount-table
          :item="item"
          :buy-sell="buySell"
          :trade-ticket="tradeTicket"
          :force-table-width="'100%'"
        ></volume-discount-table>
      </v-card-text>
    </v-card>
  </v-tooltip>
</template>

<script>
import VolumeDiscountTable from '@/components/catalog/VolumeDiscountTable'
import productMixin from '@/mixins/product'

export default {
  components: {VolumeDiscountTable},
  mixins: [productMixin],
  props: ['item', 'buySell', 'tradeTicket'],
}
</script>

<style>
.volume-discount-tooltip {
  opacity: 1 !important;
}
</style>
